import React, { useState,  } from 'react';
import { Paper, Tooltip } from '@material-ui/core';
import './NewPost.css';
import VideoCallIcon from '@material-ui/icons/VideoCall';
import AddPhotoAlternateIcon from '@material-ui/icons/AddPhotoAlternate';
import MoodIcon from '@material-ui/icons/Mood';
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import RoomIcon from '@material-ui/icons/Room';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import { db, storage,  } from '../Auth/FirebaseConfig';
import { Modal } from 'react-bootstrap';
import CloseIcon from '@material-ui/icons/Close';
import ProgressBar from 'react-bootstrap/ProgressBar';
import VideocamIcon from '@material-ui/icons/Videocam';


  


const NewPost = ({user}) => {   
    const [modal, setModal] = useState(false);
    const [image, setImage] = useState('');
    const [imageURL, setImageURL] = useState('');
    const [video, setVideo] = useState('');
    const [videoURL, setVideoURL] = useState('');
    const [postMessage, setPostMessage] = useState('');
    const [progress, setProgress] = useState(0);
    const [noLikes, setNoLikes] = useState(0);


    const handleModalClose = () => {
      setModal(false);
      console.log(setNoLikes);
    }
    const handleAllClose = () => {
        setModal(false);
        setPostMessage("");
        setProgress(0);
        setImage("");
        setImageURL("");
        setVideo("");
        setVideoURL("");
    };

    const  handleSubmitFile  = (e) => { 
      if (e.target.files[0]) {
          setImage(e.target.files[0]); 
      }
      setImageURL(URL.createObjectURL(e.target.files[0]));
    };
    const  handleSubmitFile2  = (e) => { 
      if (e.target.files[0]) {
          setVideo(e.target.files[0]); 
      }
      setVideoURL(URL.createObjectURL(e.target.files[0]));
    };

   const handleUpload = (e) => {
    if (document.getElementsByClassName('prog')[0]) {
        document.getElementsByClassName('prog')[0].classList.remove('prog');
    }

    if (!postMessage  && !imageURL && !videoURL) {
        alert("Please Write on Post")
        } else {
        e.preventDefault(); 
        if ( !imageURL && !videoURL) {
            db.collection("posts").add({
                proImage:user.photoURL ,
                postDate: new Date().toLocaleString(),
                postMessage,
                noLikes,
                proName: user.displayName,
                proId: user.uid
            });
            handleAllClose();    
          } 
        if(!videoURL){
        const uploadTask = storage.ref(`images/${image.name}`).put(image);
            uploadTask.on(
                "state_changed",
                (snapshot) => {const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                    setProgress(progress);
                } , (error) => {
                    alert(error.message);
                } , () => {
                storage.ref("images").child(image.name).getDownloadURL()
                    .then(url => {
                        db.collection("posts").add({
                            postImage: url,
                            proName: user.displayName,
                            proId: user.uid,
                            proImage : user.photoURL,
                            postDate: new Date().toLocaleString(),
                            postMessage,
                            noLikes,
                        });
                        handleAllClose();
                    })
                    }
                ) 
              }               
        if(!imageURL && videoURL){
          const uploadTask = storage.ref(`videos/${video.name}`).put(video);
            uploadTask.on(
            "state_changed",
            (snapshot) => {const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                setProgress(progress);
            } , (error) => {
                alert(error.message);
            } , () => {
            storage.ref("videos").child(video.name).getDownloadURL()
                .then(url => {
                db.collection("posts").add({
                    postVideo: url,
                    proName: user.displayName,
                    proId: user.uid,
                    proImage : user.photoURL,
                    postDate: new Date().toLocaleString(),
                    postMessage,
                    noLikes,
                });
                handleAllClose();
            })
            }
          )
        }
       }
      }
 
    return (    
        <div> 
        <div className='mt-4'>
        <Paper className='newPost' elevation={1}>
           <img src={user.photoURL} alt="" height='50px' width='50px' className='rounded-circle mr-3'/> 
           <button type="button" className="postBtn" onClick={() => setModal(true)} >
            <p>{`What's on your mind, ${user.displayName}?`}</p> 
           </button>
          <Modal show={modal} onHide={handleModalClose} centered>
                 <Modal.Header >
                 <h3 className="modal-title" id="exampleModalLabel">Create Post</h3>
                 <CloseIcon className="closeModalIcon" onClick={handleAllClose} />
                 </Modal.Header>
                 <Modal.Body>
                  <div className="d-flex">
                     <img src={user.photoURL} alt="" height='50px' width='50px' className='rounded-circle mr-2'/> 
                     <h3>{user.displayName}</h3>
                  </div>
                  <div className="postInput mt-4">
                  <input type="text" className="inputField" 
                      placeholder= {`What's on your mind, ${user.displayName}?`}
                      value={postMessage} onChange={(e) => setPostMessage(e.target.value)} 
                  />
                  </div>
                  <div className={`previewImage ${!image && "vanish"}`}>
                     <img src={imageURL} className="" alt=''/>
                  </div>
                  <img alt="" className="colorAlpha mb-3" src="https://facebook.com/images/composer/SATP_Aa_square-2x.png"/>
                  <ProgressBar variant="info" now={progress} className="prog mb-2"/>
                  <div className="addMore d-flex">
                    <h4>Add to Your Post</h4>
                    <Tooltip title="Photo">
                    <label htmlFor="addPhoto">
                    <PhotoLibraryIcon style={{color: '#41B35D',fontSize:'30px'}} className="addMoreIcon"/>
                    </label> 
                    </Tooltip> 
                <input type="file" id="addPhoto" accept="image/*" onChange={handleSubmitFile}/>
                    <Tooltip title="Tag friend">
                    <GroupAddIcon style={{color: '#1771E6',fontSize:'30px',marginLeft:'15px'}}/>
                    </Tooltip>
                    <Tooltip title="Filling/Activity">
                    <MoodIcon style={{color: '#EAB026',fontSize:'30px',marginLeft:'15px'}}/>
                    </Tooltip>
                    <Tooltip title="Check in">
                    <RoomIcon style={{color: '#E94F3A',fontSize:'30px',marginLeft:'15px'}}/>
                    </Tooltip>
                    <Tooltip title="Video">
                    <label htmlFor="addVideo">
                    <VideocamIcon style={{color: '#41B35D',fontSize:'30px',marginLeft:'15px'}} className=""/>
                    </label> 
                    </Tooltip> 
                <input type="file" id="addVideo" accept="video/*" onChange={handleSubmitFile2}/>
                    <Tooltip title="More">
                    <MoreHorizIcon style={{color: '#5B626A',fontSize:'30px',marginLeft:'15px'}}/>
                    </Tooltip>
                  </div>
                  </Modal.Body>
                 <Modal.Footer className='postFooter'>
                 <button onClick={handleUpload} type="submit" 
                    className={`newPostButton ${!imageURL && "disable"} ${!postMessage  && "disabled"} `}> Post
                  </button> 
                 </Modal.Footer>
            </Modal>        
           <hr/>
           <div className="font">
           <span className="fontIcon"><VideoCallIcon style={{color: '#E42645',fontSize:'30px'}} /> Live Video </span>
           <span className="fontIcon"  onClick={() => setModal(true)}>
              <AddPhotoAlternateIcon style={{color: '#41B35D',fontSize:'30px'}}/> Photo/Video  
           </span>
           <span className="fontIcon"><MoodIcon style={{color: '#ECC364',fontSize:'30px'}} /> Felling/Activity</span>
           </div>
        </Paper>
        </div> 
        </div>
    );
};

export default NewPost;